export default __webpack_public_path__ + "static/media/screen_zendesk_4.e31128c2.png";